/* eslint import/prefer-default-export: 0 */

export const FAVORITE = 'favorite';
export const UNSUBMITTED = 'unsubmitted';
